module.exports = "/_next/static/images/f49af245bed61ce13ce9ec56f92e86d8-hero-lg.png.webp";